// dependencies
import { ApolloClient, InMemoryCache, createHttpLink } from "@apollo/client";
// need to instantiate fetcher for Apollo to use
import "cross-fetch/polyfill";

export const getReportingURI = () => {
	const currentDomain = window.location.host;

	switch (currentDomain) {
		case "talent.performyard.com":
			return "https://reporting.talent.performyard.com/graphql";

		case "demo.talent.performyard.com":
			return "https://reporting.demo.talent.performyard.com/graphql";

		case "sandbox.talent.performyard.com":
			return "https://reporting.sandbox.talent.performyard.com/graphql";

		case "staging.talent.performyard.com":
			return "https://reporting.staging.talent.performyard.com/graphql";

		case "preview.talent.performyard.com":
			return "https://reporting.preview.talent.performyard.com/graphql";

		case "localhost:8888":
			return "http://localhost:3000/graphql";

		default:
			// If it's a temp deployment, it will point to staging reporting. *.talent.performyard.com
			if (/talent\.performyard\.com$/.test(currentDomain)) {
				return "https://reporting.staging.talent.performyard.com/graphql";
			}
			// Returns a dev env reporting endpoint *.staging.performyard.com
			return `https://reporting.${currentDomain}/graphql`;
	}
};

let apolloClient;
const reportingURI = getReportingURI();

const link = createHttpLink({
	uri: reportingURI,
	credentials: "include",
});

function createApolloClient() {
	return new ApolloClient({
		cache: new InMemoryCache({
			addTypename: false,
			typePolicies: {
				CustomField: {
					fields: {
						type: {
							read(name, { readField }) {
								if (readField("name") === "Manager") {
									return "manager";
								}
								return name;
							},
						},
					},
				},
			},
		}),
		link,
	});
}

export function initializeApolloClient() {
	// eslint-disable-next-line no-underscore-dangle
	const _apolloClient = apolloClient ?? createApolloClient();
	if (!apolloClient) apolloClient = _apolloClient;

	return _apolloClient;
}
